<template>
  <div class="data-assistant-page-cont data-assistant-myDataAssistant">
    <div class="data-assistant-myDataAssistant-head">
      <span class="model-title">我的数据助手</span>
      <span class="model-time">
          <el-date-picker
            v-model="searchData.dateData"
            type="daterange"
            value-format="timestamp"
            align="right"
            size="mini"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="pickerOptions">
          </el-date-picker>
      </span>
    </div>

    <div class="content-module-main">
      <div class="main-row" style="min-height: 320px">
        <!-- 登录频次 -->
        <div class="main-col">
          <LoginNum
            ref="loginNum"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
            :days="days"
          />
        </div>
        <div class="main-space"></div>
        <!-- 询盘查看及报价数量趋势  -->
        <div class="main-col">
          <InquiryView
            ref="inquiryView"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
            :days="days"

          />
        </div>
        <div class="main-space"></div>
      </div>

      <div class="main-row" style="min-height: 310px">
        <!-- 用户访问趋势 -->
        <div class="main-col">
          <UserVisit
            ref="userVisit"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
            :days="days"

          />
        </div>
        <div class="main-space"></div>
        <!-- 用户访问来源   v-if="loginNumList && loginNumList.length > 0" -->
        <div class="main-col">
          <FileBrowsing
            ref="loginRate"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
          />
        </div>
        <div class="main-space"></div>
      </div>
      
      <div class="main-row" style="min-height: 310px">
        <!-- 来访用户地域分布 -->
        <div class="main-col">
          <ArealDistribution
            ref="arealDistribution"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
          />
        </div>
        <div class="main-space"></div>
        <!-- 对我感兴趣的 v-if="loginNumList && loginNumList.length > 0"    -->
        <div class="main-col">
          <DockBuyer
            ref="dockBuyer"
            :startTime="searchData.startTime"
            :endTime="searchData.endTime"
          />
        </div>
        <div class="main-space"></div>
      </div>
     
    </div>

    
  </div>
</template>

<script>
import moment from "moment";

import DockBuyer from "./dockBuyer.vue";
import InquiryView from "./inquiryView.vue";
import UserVisit from "./userVisit.vue";
import FileBrowsing from "./fileBrowsing.vue";
import ArealDistribution from "./arealDistribution.vue";
import LoginNum from "./loginNum.vue";
// import { getDataDetail } from "@/utils/api/dashboard";
export default {
  components: {
    ArealDistribution,
    DockBuyer,
    FileBrowsing,
    LoginNum,
    InquiryView,
    UserVisit
  },
  data() {
    return {
      tableData: [],
      searchData: {
        dateData: [ new Date().setMonth(new Date().getMonth()-6), new Date() ],
        startTime: moment(new Date().setMonth(new Date().getMonth()-6)).format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
      },
      days: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近两周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一个月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 1)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近三个月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 3)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近半年',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setMonth(start.getMonth() - 6)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一年',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setFullYear(start.getFullYear() - 1)
              start.setHours(0, 0, 0, 0)
              end.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            },
          },
            
        ],
      },
    }
  },
  methods: {
    handleFormatDateAndTime(value) {
      if (value) {
          return moment(value).format("YYYY-MM-DD");
      }
      return "--";
    },
    // 日期切换
    dateChange() {
      if (this.searchData.dateData&&this.searchData.dateData.length!=0) {
        this.searchData.startTime = this.handleFormatDateAndTime(this.searchData.dateData[0]) ;
        this.searchData.endTime = this.handleFormatDateAndTime(this.searchData.dateData[1]);
        this.$emit('getTime',this.searchData.startTime,this.searchData.endTime);
        this.getDays(this.searchData.endTime,this.searchData.startTime)
      } else {
        this.searchData.startTime = moment(new Date().setMonth(new Date().getMonth()-6)).format('YYYY-MM-DD')
        this.searchData.endTime = moment().format('YYYY-MM-DD')
        this.$emit('getTime',this.searchData.startTime,this.searchData.endTime);
        this.getDays(this.searchData.endTime,this.searchData.startTime)


      }
    },
    // 计算天数
    getDays(endTime,startTime){
      this.days = moment(endTime).diff(startTime,'day')+1;
    },
  },
  created() {
    this.getDays(this.searchData.endTime,this.searchData.startTime)
    const listEle= document.querySelector('.el-scrollbar-wrap');
    listEle.scrollTop = 0;
  },
 

}
</script>


<style lang="scss">
.data-assistant-myDataAssistant {
  background: #fff;
  padding: 20px 0 4px 20px;
  &-head {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
    .model-time{
      position: relative;
      top: -8px;
    }
  }
  .content-module-main {
    .main-row {
      display: flex;
      // flex-wrap: wrap;
      .main-col {
        flex: 1;
        margin-bottom: 12px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 4px;
        .col-chart-box {
          .col-chart-head {
            height: 44px;
            line-height: 44px;
            // display: flex;
            // justify-content: space-between;
            padding: 0 25px 0 20px;
            align-items: center;
            // position: relative;
            .left {
              display: flex;
              // justify-content: center;
              // align-items: baseline;
              align-items: center;
              &-title{
                font-size: 14px;
                color: #16181A;
                font-family: SourceHanSansCN-Medium;;
              }
              // h4 {
              //   height: 20px;
              //   line-height: 20px;
              //   font-family: PingFangSC-Regular;
              //   font-size: 14px;
              //   color: #333;
              //   flex-shrink: 0;
              // }
              i.icon-icon-zhuming2 {
                height: 14px;
                line-height: 14px;
                font-size: 14px;
                color: #999;
                margin-left: 10px;
              }
              .time {
                margin-left: 24px;
                // margin-left: 34px;
                // height: 12px;
                line-height: 12px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999;
              }
            }
            .right {
              height: 28px;
              ul {
                display: flex;
                li {
                  width: 64px;
                  height: 24px;
                  box-sizing: border-box;
                  position: relative;
                  background: #fff;
                  margin-right: 10px;
                  font-family: PingFangSC-Regular;
                  line-height: 24px;
                  font-size: 12px;
                  color: #666;
                  text-align: center;
                  cursor: pointer;
                  border-radius: 4px;
                  transition: all 0.3s;
                  user-select: none;
                  border: 1px solid #eee;
                  &:nth-last-child(1) {
                    margin-right: 0;
                  }
                  &.active {
                    background: #1288db;
                    width: 64px;
                    height: 24px;
                    color: #fff;
                    cursor: auto;
                    border: 0;
                  }
                }
              }
            }
            // &.line {
            //   &::after {
            //     content: " ";
            //     display: block;
            //     position: absolute;
            //     height: 0;
            //     width: 100%;
            //     left: 0;
            //     bottom: 0;
            //     border-bottom: 1px solid #eee;
            //   }
            // }
          }
          .col-chart-view {
          }
          .col-chart-content{
            text-align: center;
            &-img{
              margin-top:30px;
                img{
                  width: 255px;
                  height: 154px;
                }
            }
            &-intro{
              color: #4F5D78;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
            }
          }
        }
      }
      .main-space {
        width: 20px;
      }
    }
  }
  
}

</style>